<template>
    <div id="app">
        <div class="background"></div>
        <div class="title">
            {{title}}
            <div class="menuBtn" @click="shade = !shade">≡</div>
        </div>
        <div v-show="shade" class="shade" @scroll.stop>
            <v-menu @url-change="shade = false"></v-menu>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import vMenu from "@/components/menu.vue";
export default {
    components: {
        vMenu
    },
    data() {
        return {
            title: "首府天气",
            shade: false
        };
    },
    watch: {
        $route(to) {
            this.title = to.meta.title;
            document.title = to.meta.title;
        }
    }
};
</script>
<style>
body {
    padding: 0;
    margin: 0;
}
.full {
    position: absolute;
    top: 32px;
    bottom: 0;
    left: 0;
    right: 0;
}
.background {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-image: linear-gradient(#141777, #08a9bd);
    z-index: -1;
}
.title {
    color: white;
    text-align: center;
    padding: 5px;
    position: sticky;
    top: 0;
    z-index: 99;
    background-image: linear-gradient(#141777, #141e7a);
}
.menuBtn {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 1.5rem;
}

.shade {
    position: fixed;
    top: 31px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999999;
}
.noContent {
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    background-color: rgba(0, 0, 0, 0.3);
    padding: 10px;
}

.amap-logo{
    display: none!important;
}
.amap-copyright{
    display: none!important;
}
</style>